import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import { themed } from '@indeed/ifl-css';
import { StyledDetailsSummary, StyledDetailsBody, StyledDetails } from './Details.js';
import { forwardRef, useState, useEffect } from 'react';
import { DetailsGroupContext } from './useDetailsGroupContext.js';
import { useCollection } from '../../hooks/useCollection.js';
import { sanitizeSx } from '../../utils/sanitizeSx.js';
import { jsx } from '@emotion/react';
import '../../index-26fc6478.js';
import '@indeed/ifl-icons';
import '../../utils/createResponsive.js';
import '@indeed/ihl-use-id';
import '../../hooks/useMergeRefs.js';
import '../../utils/warn.js';
import '../../utils/warnDeprecation.js';
import '../Text/Text.js';
import '../Box/Box.js';

const StyledDetailsGroup = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  styleProps: [],
  shouldForwardProp: prop => prop !== "borderless" && prop !== "heading" && prop !== "activeIndices" && prop !== "defaultActiveIndices",
  target: "enlgwbj0"
} : {
  styleProps: [],
  shouldForwardProp: prop => prop !== "borderless" && prop !== "heading" && prop !== "activeIndices" && prop !== "defaultActiveIndices",
  target: "enlgwbj0",
  label: "StyledDetailsGroup"
})(() => {
  return {
    inlineSize: "100%",
    "&>div:not(:first-of-type)": {
      marginBlockStart: "-1px"
    },
    "&>div:first-of-type": {
      [`&>${StyledDetailsSummary}`]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    "&>div:last-of-type": {
      [`&>${StyledDetailsSummary}`]: {
        borderStartEndRadius: 0,
        borderStartStartRadius: 0
      }
    },
    "&>div:not(:last-of-type)": {
      [`${StyledDetailsBody}`]: {
        borderRadius: 0
      }
    },
    "&>div:not(:first-of-type):not(:last-of-type)": {
      [`&>${StyledDetailsSummary}`]: {
        borderRadius: 0
      }
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const DetailsGroup = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    size = "md",
    defaultActiveIndices,
    activeIndices,
    onActiveIndicesChange,
    sx,
    ...props
  } = _ref;
  const replacedStyles = sanitizeSx(sx ?? {}, "details", `${StyledDetails}`) ?? {};
  const {
    registerItem,
    getItemIndexById
  } = useCollection();
  const [openItems, setOpenItems] = useState(defaultActiveIndices !== undefined ? defaultActiveIndices : activeIndices !== undefined ? activeIndices : []);
  const handleOnChange = newIndices => {
    if (activeIndices && activeIndices.length) {
      setOpenItems(activeIndices);
      if (onActiveIndicesChange) {
        onActiveIndicesChange(newIndices); // for controlled behavior
      }
      return;
    }
    setOpenItems(newIndices);
    if (onActiveIndicesChange) {
      onActiveIndicesChange(newIndices);
    }
  };
  useEffect(() => {
    if (activeIndices && activeIndices !== openItems) {
      setOpenItems(activeIndices);
      return;
    }
  }, [activeIndices, openItems]);
  const context = {
    openItems,
    handleOnChange,
    registerItem,
    getItemIndexById,
    contextSize: size
  };
  return jsx(DetailsGroupContext.Provider, {
    value: context
  }, jsx(StyledDetailsGroup, _extends({
    ref: ref,
    sx: replacedStyles
  }, props), children));
});
DetailsGroup.displayName = "DetailsGroup";

export { DetailsGroup, StyledDetailsGroup };
